import { render, staticRenderFns } from "./DonutChartCard.vue?vue&type=template&id=3a4cf23c&scoped=true&"
import script from "./DonutChartCard.vue?vue&type=script&lang=js&"
export * from "./DonutChartCard.vue?vue&type=script&lang=js&"
import style0 from "./DonutChartCard.vue?vue&type=style&index=0&id=3a4cf23c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4cf23c",
  null
  
)

export default component.exports